(() => {
  const formatMoney = (cents) => {
    return `${(Number(cents) / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}TL`;
  };

  const getProductUrl = (card) => {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;

    const url = new URL(link.href, window.location.origin);
    return url.pathname;
  };

  const makeIdsUnique = (root, suffix) => {
    root.querySelectorAll('[id]').forEach((el) => {
      el.id = `${el.id}-${suffix}`;
    });
  };

  const updateCard = (card, product, variant, colorName) => {
    const variantUrl = `${window.location.origin}${product.url}?variant=${variant.id}`;

    card.dataset.variantId = String(variant.id);
    card.dataset.variantColor = colorName;
    card.dataset.variantExpanded = 'true';

    /* Tüm ürün linklerini ilgili varyanta yönlendir */
    card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      link.href = variantUrl;
    });

    /* Varyantın ana görselini kullan */
    const imageUrl =
      variant.featured_image?.src ||
      variant.featured_image ||
      variant.featured_media?.preview_image?.src;

    if (imageUrl) {
  const images = card.querySelectorAll(
    'card-gallery img, .card-gallery img, .product-media-container img'
  );

  let primaryImageUrl = imageUrl;
  let hoverImageUrl = null;

  const mediaMapElement = card.querySelector('.variant-color-media-urls');

  if (mediaMapElement) {
    try {
      const mediaMap = JSON.parse(mediaMapElement.textContent.trim());
      const colorImages = mediaMap[colorName];

      if (Array.isArray(colorImages) && colorImages.length > 0) {
        primaryImageUrl = colorImages[0] || imageUrl;

        if (colorImages.length > 1) {
          hoverImageUrl = colorImages[1];
        }
      }
    } catch (error) {
      console.warn(
        'Renk medya eşlemesi okunamadı:',
        product.title,
        colorName,
        error
      );
    }
  }

  /* Ana kart görseli */
  if (images[0]) {
    images[0].src = primaryImageUrl;
    images[0].removeAttribute('srcset');
    images[0].removeAttribute('sizes');
  }

  /* Aynı rengin ikinci görseli */
  if (images[1] && hoverImageUrl) {
    images[1].src = hoverImageUrl;
    images[1].removeAttribute('srcset');
    images[1].removeAttribute('sizes');
  }
}

    /* İlgili varyant fiyatını göster */
    const priceContainer = card.querySelector('product-price');

    if (priceContainer && variant.price != null) {
      const priceElements = priceContainer.querySelectorAll(
        '.price, .price-item, [data-price], .money'
      );

      if (priceElements.length) {
        priceElements.forEach((el, index) => {
          if (index === 0) {
            el.textContent = formatMoney(variant.price);
          }
        });
      } else {
        priceContainer.textContent = formatMoney(variant.price);
      }
    }

    card.querySelectorAll('[data-product-id]').forEach((el) => {
      el.dataset.variantId = String(variant.id);
    });
  };

  const expandColorProductCard = async (originalCard) => {
    if (!originalCard) return;

    if (
      originalCard.dataset.variantExpanded === 'true' ||
      originalCard.dataset.variantExpanded === 'loading'
    ) {
      return;
    }

    if (originalCard.dataset.variantCardClone === 'true') {
      return;
    }

    originalCard.dataset.variantExpanded = 'loading';

    try {
      const productPath = getProductUrl(originalCard);

      if (!productPath) {
        originalCard.dataset.variantExpanded = 'true';
        return;
      }

      const response = await fetch(`${productPath}.js`, {
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`Product JSON could not be loaded: ${productPath}`);
      }

      const product = await response.json();

      /* Renk seçeneğini bul */
      const colorOptionIndex = product.options.findIndex((option) => {
        const name =
          typeof option === 'string'
            ? option
            : option.name;

        return String(name)
          .trim()
          .toLocaleLowerCase('tr-TR') === 'renk';
      });

      /* Renk varyantı olmayan ürünlere dokunma */
      if (colorOptionIndex === -1) {
        originalCard.dataset.variantExpanded = 'true';
        return;
      }

      const variantsByColor = new Map();

      product.variants.forEach((variant) => {
        /* O renkte en az bir stoklu varyant olmalı */
        if (!variant.available) return;

        const colorName = variant[`option${colorOptionIndex + 1}`];

        if (!colorName) return;

        /* Her renk için ilk stoklu varyant */
        if (!variantsByColor.has(colorName)) {
          variantsByColor.set(colorName, variant);
        }
      });

      /* Tek stoklu renk varsa kartı çoğaltmaya gerek yok */
      if (variantsByColor.size <= 1) {
        originalCard.dataset.variantExpanded = 'true';
        return;
      }

      const parent = originalCard.parentElement;

      if (!parent) {
        originalCard.dataset.variantExpanded = 'true';
        return;
      }

      const entries = Array.from(variantsByColor.entries());

      let insertAfter = originalCard;

      entries.forEach(([colorName, variant], index) => {
        let card;

        if (index === 0) {
          card = originalCard;
        } else {
          card = originalCard.cloneNode(true);

          card.dataset.variantCardClone = 'true';

          makeIdsUnique(card, variant.id);

          insertAfter.insertAdjacentElement('afterend', card);
          insertAfter = card;
        }

        updateCard(card, product, variant, colorName);
      });

      originalCard.dataset.variantExpanded = 'true';

    } catch (error) {
      console.error('Variant collection card error:', error);

      originalCard.dataset.variantExpanded = 'true';
    }
  };

  const runVariantCards = () => {
    document
      .querySelectorAll(
        '.product-grid__item[data-product-id]:not([data-variant-expanded]):not([data-variant-card-clone="true"])'
      )
      .forEach((card) => {
        expandColorProductCard(card);
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runVariantCards);
  } else {
    runVariantCards();
  }

  /*
   * Filtreleme, sıralama ve infinite scroll sonrası
   * Shopify yeni kart eklerse onları da otomatik işle.
   */
  const observer = new MutationObserver(() => {
    runVariantCards();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();